import React from "react";
import { motion } from "framer-motion";

const ProcessHeader = () => {
  return (
    <div className="lg:space-y-[20px]">
      <div>
        <motion.span 
          initial={{ opacity: 0, y: -30 }}
          viewport={{ once: false }}
          whileInView={{ opacity: 1, y: 0, transition: { delay: 0.5 } }}
          className="text-3xl lg:text-5xl font-[TAEBAEKfont] drop-shadow-2xl 
                     after:block after:absolute after:top-[60%] after:-inset-1 after:-skew-y-2 after:bg-red-500 after:opacity-20 after:h-[20px]"
        >
          PROCESS
        </motion.span>
      </div>
      
      <div className="text-xl font-[SUIT-Regular] drop-shadow-2xl">
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          viewport={{ once: false }}
          whileInView={{ opacity: 1, y: 0, transition: { delay: 0.7 } }}
        >
          체계적인 <span className="text-rose-500 font-bold">프로세스</span>를 통해 
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          viewport={{ once: false }}
          whileInView={{ opacity: 1, y: 0, transition: { delay: 1 } }}
        >
          고객이 만족하는 높은 완성도의 결과물<span className="hidden lg:block">을 제작합니다.</span>
        </motion.div>
      </div>
    </div>
  );
};

export default ProcessHeader; 